module.exports = __webpack_public_path__ + "static/media/EC-min.fd0d977a.png";